import { Link } from 'react-router-dom'
import { Grid } from '@mui/material'

import { colours } from '../settings/settings'

const GridCard = ({ title, subtitle1, subtitle2, linkTo, isError = false }) => {
  const GridContent = () => {
    return (
      <Grid
        container
        padding={2}
        rowSpacing={1}
        sx={{
          width: '100%',
          color: colours.greyVeryDark,
          border: 1,
          borderRadius: 2,
          borderColor: !!isError ? colours.redDark : colours.blueDark,
          background: `linear-gradient(0deg, transparent 25%, ${
            !!isError ? colours.redError : colours.blueBack
          } 100%)`,
        }}
      >
        {!!title && (
          <Grid size={12}>
            <b
              style={{
                fontSize: 24,
                color: !!isError ? colours.redDark : colours.blueVeryDark,
              }}
            >
              {title.toUpperCase()}
            </b>
          </Grid>
        )}
        <Grid size={12}>{subtitle1 || '-'}</Grid>
        <Grid size={12}>{subtitle2 || '-'}</Grid>
      </Grid>
    )
  }

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
      {!!linkTo ? (
        <Link to={linkTo} style={{ textDecoration: 'none', width: '100%' }}>
          {GridContent()}
        </Link>
      ) : (
        GridContent()
      )}
    </Grid>
  )
}

export default GridCard
